import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { Customer } from "./customer";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { DatePipe } from "@angular/common";
import { Subscription } from "rxjs/Subscription";
import { AppState } from "../../../app.service";
import { AlertService } from "../../../services";
import { UserManagementService } from "../user/user-management.service";
import { CustomerManagementFieldService } from "./customer-management-field.service";
import { CustomerManagementService } from "./customer-management.service";
import { IMyDateModel } from "mydatepicker";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { DynamicFormComponent } from "../../dynamic-form/dynamic-form.component";
import { PermissionService } from "../../../services/SecurityServices/permission.service";
import { HttpClient } from "@angular/common/http";

@Component({
    template: require('./customer-management.html'),
    providers: [CustomerManagementFieldService, UserManagementService, CustomerManagementService, DatePipe],
    styles: [require('../dynamic-form.css'), require('../tab.css'), require('./customer.css')]
})

export class CustomerManagementComponent implements OnInit {

    public mobileNumber: string = '';
    public fields: FormControlBase<any>[] = null;
    public loyaltypointsfields: FormControlBase<any>[];
    public disableForm: boolean = false;
    public showLoyaltyTransactionLogs: boolean = false;
    public customer: Customer;
    public initialId: string;
    private busy: Subscription;
    private tabIndex = 0;
    private tabs: Array<any> = [
        { active: true, label: 'Create/Update' },
        { active: false, label: 'Point Balances'}
    ];

    @ViewChild('customerForm') customerFormComponent: DynamicFormComponent;
    @ViewChild('loyaltypointsForm') loyaltypointsFormComponent: DynamicFormComponent;

    constructor(
        private appState: AppState,
        private alertService: AlertService,
        private formControlService: CustomerManagementFieldService,
        private route: ActivatedRoute,
        private userManagementService: UserManagementService,
        private customerManagementService: CustomerManagementService,
        private router: Router,
        private permissionService: PermissionService,
        private http: HttpClient
    ) {
    }

    private setTab(selectedTab: any): void {
        for (let tab of this.tabs) {
            tab.active = false;
        }
        selectedTab.active = true;
        this.tabIndex = this.tabs.indexOf(selectedTab);
    }

    private revertForm(): void {
        this.customerFormComponent.form.patchValue(this.customer);
    }

    private submitForm(): void {
        let copy: any = Object.assign({
            userId: this.customer.userId
        }, this.customerFormComponent.form.value);
        copy = Object.assign(copy, this.loyaltypointsFormComponent.form.value);
        copy.statusId = copy.statusId ? 2 : 1;
        copy.anniversary = this.convertToDate(copy.anniversary); 
        copy.dateOfBirth = this.convertToDate(copy.dateOfBirth);
        copy.enrollmentDate = this.convertToDate(copy.enrollmentDate);
        copy.rewardCount = copy.rewardCount;
        copy.unitCount = copy.unitCount;
        
        let self: CustomerManagementComponent = this;
        let formF = this.loyaltypointsfields;
        let changeV = copy.changeReasonItem;
        let sendRedemptionPinPrompt: boolean = copy.sendRedemptionPinPrompt;
        if (changeV === undefined || changeV === null || changeV === '') {copy.changeReason = ''}
       if(copy.changeReason !== ''){
            copy.changeReason = changeV + ': ' + copy.changeReason;
        }
        else{
            if(changeV !== 'Other' && changeV !== 'Complaint' && changeV !== 'Customer Flagged'){copy.changeReason = changeV;}
        }
        if (this.initialId == 'new') {
            copy.permissionsValue = 32;
            this.http.post<any>(CustomerManagementService.getCustomerUrl, copy).subscribe(() => {
                self.router.navigate(['admin/customer-management']);
            }, (err) => {console.log(err)});
            return;
        }
        this.http.put<any>(CustomerManagementService.getCustomerUrl, copy).subscribe(() => {
            self.router.navigate(['admin/customer-management']);
        }, (err) => {console.log(err)});
    }

    private convertToDate(model: IMyDateModel): Date {
        return model.jsdate ? new Date(model.jsdate.getTime() + -1 * (new Date().getTimezoneOffset() * 60000)) : null;
    }

    private getDate(propName: string, date: Date): any {
        let result: any = {};
        result[propName] = {
            date: {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
            }
        };
        return result;
    
    }
    ngOnInit() {
        let self: CustomerManagementComponent = this;
        this.showLoyaltyTransactionLogs = this.permissionService.userHasPermission('View_LoyaltyTransactionLogs');
        this.route.paramMap
            .switchMap((params: ParamMap) => {
                self.initialId = params.get('id');
                self.fields = self.formControlService.getFields();
                self.loyaltypointsfields = self.formControlService.getLoyaltyPointsFields();
                let observable = this.customerManagementService.getCustomer(params.get('id'));
                self.busy = observable.subscribe();
                return observable;
            })
            .subscribe((customer: Customer) => {
                self.customer = customer;
                if (self.initialId !== 'new') {
                    self.tabs.push({ active: false, label: 'Transaction Log' });
                    self.mobileNumber = self.customer.mobileNumber;
                }
                self.disableForm = !self.permissionService.userHasPermission(self.initialId == 'new' ? 'Customers_PostUser' : 'Customers_UpdateUser');
                self.fields = self.formControlService.getFields();
                setTimeout((self, customer) => self.setCustomerForm(customer), 50, self, customer);                     
            });
    }

    private setCustomerForm(customer: Customer) {
        this.customerFormComponent.form.patchValue(customer);
        this.loyaltypointsFormComponent.form.patchValue(customer);
        if (customer.dateOfBirth) {
            this.customerFormComponent.form.patchValue(this.getDate('dateOfBirth', customer.dateOfBirth));
        }
        if (customer.anniversary) {
            this.customerFormComponent.form.patchValue(this.getDate('anniversary', customer.anniversary));
        }
        if (customer.enrollmentDate) {
            this.customerFormComponent.form.patchValue(this.getDate('enrollmentDate', customer.enrollmentDate));
        }  
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer-management.component.ts